/* template */
<template minapp="mpx" xlang="wxml"><div class="es-picker"><div class="es-picker__toolbar" v-if="(showToolBar)"><mpx-view @tap="onCancel" class="es-picker__cancel">{{cancelText}}</mpx-view><div class="es-picker__title">{{title}}</div><mpx-view @tap="onConfirm" class="es-picker__confirm">{{confirmText}}</mpx-view></div><div class="es-picker__columns"><mpx-picker-view :indicator-style="(itemStyle)" :immediate-change="(immediateChange)" :style="[(rootStyle)] | transRpxStyle" :value="(value)" @change="onChange"><mpx-picker-view-column v-for="(item, index) in (columns)" :key="item.index"><div :style="[(itemStyle)] | transRpxStyle" v-for="(column, columnsIndex) in (item)" :key="column.column" class="es-picker-column__text">{{column}}</div></mpx-picker-view-column></mpx-picker-view></div></div></template>

/* styles */
<style scoped mpxStyleOptions='{"mid":"m65c978b8"}'>
.es-picker{
  overflow: hidden;
  background: #fff;
  border-radius: 16px 16px 0  0;
}
.es-picker__toolbar{
  position: relative;
  display: flex;
  align-items: center;
  padding: 12px;
  font-size: 14px;
  justify-content: space-between;
}
.es-picker__toolbar::after{
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  right: -50%;
  bottom: -50%;
  border-bottom: 1px solid #ebebeb;
  transform: scale(0.5);
  box-sizing: border-box;
}
.es-picker-column__text{
  display: flex;
  align-items: center;
  justify-content: center;
}
.es-picker__cancel{
  color: #969799;
}
.es-picker__confirm{
  color: #576b95;
}
.es-picker__title{
  max-width: 50%;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
   
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m65c978b8"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex65c978b8%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex65c978b8%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m65c978b8"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index65c978b8/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-picker-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-picker-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-picker-view-column':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-picker-view-column.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
